// extracted by mini-css-extract-plugin
module.exports = {"submitButton":"AuthFormComponent_submitButton__3ucEA"};